export default {"src":"/_next/static/media/white-facebook-icon.a7fe718e.svg","height":49,"width":48};